(() => {
  'use strict';
  const initPromo = (root) => {
    if (!root || root.dataset.v4PromoReady === 'true') return;
    root.dataset.v4PromoReady = 'true';
    const track = root.querySelector('.v4-promo-track');
    const cards = [...root.querySelectorAll('.v4-promo-card')];
    const dots = [...root.querySelectorAll('.v4-promo-dots i')];
    if (!track || cards.length < 2 || !dots.length) return;
    const update = () => {
      const center = track.scrollLeft + track.clientWidth / 2;
      let active = 0, best = Infinity;
      cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const distance = Math.abs(cardCenter - center);
        if (distance < best) { best = distance; active = index; }
      });
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
    };
    let frame = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive:true});
    update();
  };
  const initFeed = (root) => {
    if (!root || root.dataset.v4InfiniteReady === 'true') return;
    root.dataset.v4InfiniteReady = 'true';
    const grid = root.querySelector('[data-v4-grid]');
    const sentinel = root.querySelector('[data-v4-sentinel]');
    const status = root.querySelector('[data-v4-status]');
    if (!grid || !sentinel) return;
    let next = root.dataset.next || '';
    let busy = false;
    const setStatus = (text, loading = false) => {
      if (!status) return;
      status.hidden = !text;
      status.replaceChildren();
      if (loading) { const spinner = document.createElement('span'); spinner.className = 'v4-infinite-spinner'; status.append(spinner); }
      if (text) status.append(document.createTextNode(text));
    };
    const load = async () => {
      if (busy || !next) return;
      busy = true; setStatus('상품을 불러오는 중이에요.', true);
      try {
        const url = new URL(next, location.origin);
        url.searchParams.set('section_id', root.dataset.sectionId);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, {credentials: 'same-origin'});
        if (!response.ok) throw new Error('feed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.querySelector('[data-infinite-feed]');
        const incomingGrid = incoming?.querySelector('[data-v4-grid]');
        if (!incoming || !incomingGrid) throw new Error('feed');
        grid.append(...incomingGrid.children);
        next = incoming.dataset.next || ''; root.dataset.next = next;
        if (!next) { observer.disconnect(); sentinel.hidden = true; }
        setStatus('');
      } catch { setStatus('상품을 더 불러오지 못했어요. 아래로 다시 내려보세요.'); }
      finally { busy = false; }
    };
    const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) load(); }, {rootMargin: '500px 0px'});
    if (next) observer.observe(sentinel); else sentinel.hidden = true;
  };
  const init = (scope = document) => {
    if (scope.matches?.('.v4-promo-shell')) initPromo(scope);
    scope.querySelectorAll?.('.v4-promo-shell').forEach(initPromo);
    if (scope.matches?.('[data-infinite-feed]')) initFeed(scope);
    scope.querySelectorAll?.('[data-infinite-feed]').forEach(initFeed);
  };
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();